export default "__VITE_ASSET__16b317fc__"